import type { App } from '@cargoflow/api'
import { dashboardEnv } from '@cargoflow/env/dashboard'
import { treaty } from '@elysiajs/eden'

/**
 * Type-safe API client using Eden Treaty
 *
 * Provides end-to-end type safety between the Elysia API and React frontend.
 * All routes, request bodies, and responses are fully typed.
 *
 * @example
 * // GET request
 * const { data, error } = await api.health.get()
 *
 * @example
 * // POST request with body
 * const { data, error } = await api.shipments.post({
 *   origin: 'Paris',
 *   destination: 'Berlin',
 *   weight_kg: 1000
 * })
 */
export const api = treaty<App>(dashboardEnv.CARGO_API_URL, {
  fetch: {
    credentials: 'include',
  },
})
